exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lcdd-tchat-message .img-container {\n  height: 150px;\n}\n.lcdd-tchat-message pre {\n  margin-bottom: 0;\n}\n.lcdd-tchat-message img {\n  max-width: 90%;\n  max-height: 150px;\n}\n.lcdd-tchat-message img.emoji {\n  width: 24px;\n  height: 24px;\n}\n.lcdd-tchat-errors .alert ul {\n  margin-bottom: 0;\n}\n.lcdd-tchat-errors .alert-dismissible .close {\n  padding: 0.1rem 0.6rem;\n}", ""]);

// exports
